import { createSlice } from "@reduxjs/toolkit";
import { CustomerModel } from "../shared/models/Customer";

const initialState = {
  customersDataSource: [] as CustomerModel[],
};

const customersSlice = createSlice({
  name: "customers",
  initialState: initialState,
  reducers: {
    setCustomersDataSource(state, action) {
      state.customersDataSource = action.payload;
    },
  },
});

export const {
    setCustomersDataSource,
} = customersSlice.actions;
export const customersReducer = customersSlice.reducer;

// Selector
export const selectCustomersDataSource = (state: any) =>
  state.customers.customersDataSource;
